// extracted by mini-css-extract-plugin
module.exports = {"pagination":"-pagination-pagination-3U1cg9-","currentPage":"-pagination-currentPage-9wdXwn-","navDisabled":"-pagination-navDisabled-2QFufs-"};